function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoRealeGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 53.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0,25.44v11h29.86C21.5,30.59,11.89,26.93,0,25.44",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.24,0c1.4,2.07,2.22,4.75,2.19,7.35-.06,5.93-5.19,10.93-11.57,11.24,5.57,1.94,11.57,4.96,17.57,9.21V0h-8.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.38,7.07c0-3.49-1.93-5.8-3.41-7.07H0v14.34c13.37,1.2,26.38,2.32,26.38-7.26",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,21.5c15.11,1.19,28.92,8.51,36.44,14.93v-3.74C19.42,19.2,0,18.36,0,18.36v3.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.78,19.04l-3.92-6.73h-7.36v6.73h-3.89V1.47c0-.29-.05-.53-.18-.66-.13-.16-.37-.26-.71-.37V0h13.99c1.81,0,3.29.58,4.39,1.73,1.1,1.13,1.66,2.63,1.66,4.5,0,3.02-1.21,4.94-3.65,5.73l4.07,7.07h-4.39ZM61.92,6.1c0-.74-.24-1.32-.71-1.76-.47-.47-1.13-.68-1.92-.68h-8.78v4.99h8.78c.84,0,1.47-.24,1.95-.68.45-.45.68-1.08.68-1.87",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.68,19.04h-17.96V1.47c0-.29-.05-.5-.18-.66-.13-.16-.37-.26-.71-.37V0h18.22v3.65h-13.43v3.89h9.33v3.65h-9.33v4.18h14.06v3.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.1,19.04l-1.81-4.1h-10.25l-1.84,4.1h-3.92l7.41-16.64c.21-.39.32-.76.32-1.03,0-.45-.29-.74-.79-.92V0h6.36l8.46,19.03h-3.94ZM100.13,3.45l-3.5,7.83h6.99l-3.5-7.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.47,19.04h-16.19V1.47c0-.29-.08-.53-.21-.66-.13-.16-.34-.26-.68-.37V0h4.78v15.38h12.3v3.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,19.04h-17.95V1.47c0-.29-.05-.5-.19-.66-.13-.16-.37-.26-.71-.37V0h18.22v3.65h-13.43v3.89h9.33v3.65h-9.33v4.18h14.06v3.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.52,30.09c0,1.9-.62,3.47-1.87,4.65-1.41,1.36-3.24,2.04-5.46,2.04s-3.91-.69-5.29-2.06c-1.2-1.18-1.8-2.69-1.8-4.53s.6-3.29,1.8-4.5c1.41-1.37,3.17-2.08,5.29-2.08,2.73,0,4.75.99,6.07,2.95l-3.31,1.41-.1-.21c.05-.07.1-.12.12-.17.09-.1.1-.27.07-.38-.07-.24-.36-.46-.69-.65-.63-.34-1.37-.53-2.18-.53-1.36,0-2.45.4-3.31,1.18-.84.79-1.27,1.78-1.27,2.97,0,1.3.5,2.37,1.53,3.16.86.67,1.87,1.01,3.07,1.01,1.03,0,1.96-.24,2.78-.74.81-.46,1.39-1.08,1.73-1.87h-5.05v-2.38h7.86v.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.6,36.42l-2.56-4.39h-4.8v4.39h-2.54v-11.46c0-.19-.03-.34-.12-.43-.08-.1-.24-.17-.46-.24v-.29h9.13c1.18,0,2.15.38,2.87,1.13.72.74,1.08,1.72,1.08,2.93,0,1.97-.79,3.23-2.38,3.74l2.66,4.62h-2.87ZM79.69,27.98c0-.48-.15-.86-.46-1.15-.31-.31-.74-.45-1.25-.45h-5.73v3.26h5.73c.55,0,.96-.15,1.27-.45.29-.29.45-.7.45-1.22",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,30.2c0,1.85-.6,3.36-1.8,4.55-1.37,1.36-3.14,2.04-5.3,2.04s-3.91-.69-5.28-2.04c-1.19-1.18-1.79-2.69-1.79-4.55s.6-3.33,1.8-4.51c1.39-1.37,3.16-2.06,5.28-2.06s3.89.69,5.28,2.06c1.2,1.19,1.8,2.7,1.8,4.51M102.39,30.2c0-1.24-.41-2.25-1.22-3.02-.82-.77-1.91-1.17-3.26-1.17s-2.44.39-3.26,1.17c-.81.77-1.22,1.78-1.22,3.02s.39,2.28,1.2,3.05c.8.77,1.9,1.15,3.26,1.15s2.47-.38,3.28-1.15c.81-.77,1.22-1.78,1.22-3.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,32.24c0,1.34-.57,2.42-1.68,3.26-1.17.86-2.71,1.29-4.63,1.29s-3.47-.43-4.63-1.29c-1.12-.84-1.68-1.92-1.68-3.26v-7.29c0-.19-.05-.33-.14-.43-.07-.09-.22-.17-.45-.22v-.29h3.12v7.84c0,.77.33,1.39.99,1.85.67.46,1.6.7,2.78.7s2.11-.24,2.8-.72c.65-.46.98-1.08.98-1.84v-7.84h2.54v8.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.45,28.07c0,2.64-1.34,3.96-4.03,3.96h-5.9v4.39h-2.54v-11.46c0-.19-.05-.34-.12-.43-.09-.1-.24-.17-.46-.24v-.29h9.13c1.18,0,2.13.38,2.85,1.13.72.74,1.08,1.72,1.08,2.93M146.94,28.05c0-1.12-.56-1.66-1.72-1.66h-5.71v3.26h5.73c.53,0,.94-.14,1.25-.43.29-.29.45-.67.45-1.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,53.71h3.92v-.56h-3.3v-2.79h2.72v-.56h-2.72v-2.64h3.3v-.56h-3.92v7.11ZM136.3,48.72c0,1.09-.44,1.64-1.43,1.64h-1.7v-3.21h1.7c.99,0,1.43.53,1.43,1.57M136.44,53.71h.69l-1.42-2.92c.7-.24,1.25-.75,1.25-2.08,0-1.43-.71-2.12-2.09-2.12h-2.32v7.11h.62v-2.8h1.91l1.36,2.8ZM121.38,53.82c.63,0,1.11-.11,1.48-.33.87-.52,1.08-1.65,1.08-3.39,0-2.47-.44-3.6-2.57-3.6-.7,0-1.21.12-1.59.37-.79.51-.99,1.57-.99,3.24,0,2.48.45,3.72,2.58,3.72M121.38,53.24c-1.71,0-1.93-1.01-1.93-3.15,0-1.63.12-2.54.94-2.88.26-.11.57-.15.98-.15,1.7,0,1.91.9,1.91,3.03,0,1.61-.12,2.58-.91,2.96-.27.13-.58.19-1,.19M103.93,53.71h.6v-6.55h.13l2.01,6.32h.79l2.01-6.32h.13v6.55h.6v-7.11h-1.14l-2,6.29-2.01-6.29h-1.14v7.11ZM93.86,48.94c0,.81-.26,1.16-.89,1.16h-.96v-2.27h.96c.63,0,.89.3.89,1.11M93.98,53.71h1.5l-1.07-2.69c.54-.3.92-.88.92-2.08,0-1.75-.86-2.34-2.37-2.34h-2.41v7.11h1.44v-2.37h1.09l.89,2.37ZM77.97,53.71h4.23v-1.25h-2.78v-1.67h2.2v-1.25h-2.2v-1.67h2.78v-1.25h-4.23v7.11ZM67.84,53.71h1.44v-7.11h-1.44v2.84h-2.19v-2.84h-1.44v7.11h1.44v-3.01h2.19v3.01ZM51.53,47.86h1.58v5.86h1.44v-5.86h1.55v-1.25h-4.57v1.25ZM39.5,53.71h4.22v-1.25h-2.78v-1.67h2.2v-1.25h-2.2v-1.67h2.78v-1.25h-4.22v7.11ZM28.9,50.95h.62v1.59s-.45.04-.7.04c-1.22,0-1.44-1.02-1.44-2.5,0-1.36.24-2.35,1.48-2.35.81,0,2.06.14,2.06.14l.04-1.11s-1.03-.28-2.25-.28c-2.04,0-2.81,1.2-2.81,3.61,0,2.21.61,3.75,2.71,3.75.78,0,2.35-.19,2.35-.19v-3.89h-2.06v1.19ZM15.06,53.84c.6,0,1.08-.1,1.45-.31.89-.49,1.23-1.59,1.23-3.44,0-2.64-.7-3.61-2.69-3.61-.65,0-1.15.1-1.55.33-.81.47-1.14,1.5-1.14,3.27,0,2.64.7,3.75,2.69,3.75M15.06,52.58c-.99,0-1.2-.62-1.2-2.5,0-1.43.11-2.05.62-2.26.16-.06.36-.09.59-.09.99,0,1.2.47,1.2,2.35,0,1.42-.13,2.12-.61,2.37-.16.08-.36.13-.6.13M0,47.86h1.58v5.86h1.44v-5.86h1.55v-1.25H0v1.25Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRealeGroup);
export default __webpack_public_path__ + "static/media/Logo_RealeGroup.9aa1731ff2021b3ef047432d28b1c827.svg";
export { ForwardRef as ReactComponent };